import ambitionIcon from "../../../../assets/icons-tabs/ambition-icon-blue.svg";
import "./index.css";

export const AmbitionIntro = () => {
  return (
    <div
      style={{
        display: "flex",
        gap: "30.25px",
        paddingTop: "39px",
        paddingRight: "48px",
        marginBottom: "12.45px",
      }}
    >
      <div className="ambition-intro-card-container">
        <h5 style={{ fontWeight: "bold" }}>Ambition</h5>
        <img
          src={ambitionIcon}
          alt="Ambition Icon"
          width={70}
          height={70}
          style={{ objectFit: "cover" }}
        />
      </div>
      <div className="ambition-desc-box">
        <h5 className="ambition-desc-box-title ">Ambition</h5>
        <p className="ambition-desc-box-text">
          Here in company we start to map out that the company has paid for and
          are delivered to the location. To make this more manageable, it is
          possible to divide deliveries into sub-categories, where deliveries
          can be grouped by e.g. purchase/order number. We recommend grouping by
          supplier and if possible, by goods and services purchased for the
          production of a specific product. List deliveries of goods and
          services that the company has paid for and are delivered to the
          location. To make this more manageable, it is possible to divide
          deliveries into sub-categories, where deliveries can be grouped by
          e.g. purchase/order number. We recommend grouping by supplier and, if
          possible, by goods and services purchased for the production of a
          specific product.
        </p>
      </div>
    </div>
  );
};
